{
  "DECK_SELECTOR_TITLE": "My Decks",
  "MAP_SELECT_TITLE": "Select Map",
  "DECKBUILDER_TAB_TOWERS": "TOWERS",
  "DECKBUILDER_TAB_UNITS": "UNITS",
  "DECKBUILDER_TAB_HERO": "HERO",
  "HUD_CLOSE": "Close",
  "HUD_SURRENDER": "Surrender",
  "HUD_SURRENDER_CONFIRM": "Really surrender?",
  "HUD_WAVE": "Wave",
  "HUD_DAILY_QUESTS": "DAILY QUESTS",
  "HUD_NO_ACTIVE_QUESTS": "No active quests",
  "HUD_SPELL_READY": "Ready",
  "HUD_SPY_LABEL": "SPY",
  "HUD_UPGRADE": "Upgrade",
  "HUD_MAX_LEVEL": "MAX LEVEL",
  "HUD_DEMOLISH": "Demolish (50% refund)",
  "HUD_CHOOSE_PATH": "Choose path (irreversible):",
  "HUD_MUSIC_ON": "Enable music",
  "HUD_MUSIC_OFF": "Disable music",
  "MATCH_RESULT_NO_STATS": "No statistics available",
  "MATCH_RESULT_VICTORY": "VICTORY",
  "MATCH_RESULT_DEFEAT": "DEFEAT",
  "MATCH_RESULT_DRAW": "DRAW",
  "MATCH_RESULT_WINNER": "Winner:",
  "MATCH_RESULT_TOTAL_DAMAGE": "Total damage:",
  "MATCH_RESULT_GOLD_EARNED": "Gold earned:",
  "MATCH_RESULT_UNITS_SENT": "Units sent:",
  "MATCH_RESULT_TOWERS_BUILT": "Towers built:",
  "MATCH_RESULT_DURATION": "Match duration:",
  "MATCH_RESULT_PLAY_AGAIN": "Play Again",
  "MATCH_RESULT_MAIN_MENU": "Main Menu",
  "MATCH_RESULT_PLAYER": "You",
  "MATCH_RESULT_OPPONENT": "Opponent",
  "MATCH_RESULT_TOWER_DAMAGE": "Tower Damage",
  "MATCH_RESULT_UNITS_BREAKDOWN": "Units Sent",
  "CAMPAIGN_HUD_OBJECTIVE": "Objective:",
  "SHOP_TITLE": "Shop",
  "SHOP_GOLD_LABEL": "Gold:",
  "SHOP_GEMS_COMING_SOON": "Gem purchases will be available in the next version.",
  "SHOP_SEASON_COMING_SOON": "Subscribe — Coming Soon",
  "SHOP_TAB_PACKS": "Packs",
  "SHOP_TAB_GEMS": "Gems",
  "SHOP_TAB_SEASON": "Season Pass",
  "SHOP_BUY": "Buy",
  "SHOP_NOT_ENOUGH_GOLD": "Not enough Gold",
  "SHOP_GEMS_LABEL": "Gems",
  "SHOP_COMING_SOON_BADGE": "Coming Soon",
  "SHOP_SUBSCRIBE": "Subscribe — Coming Soon",
  "SHOP_DURATION_DAYS": "Duration:",
  "QUEST_WIDGET_TITLE": "Active Quests",
  "QUEST_WIDGET_ALL_LINK": "All Quests →",
  "MAIN_MENU_TITLE": "Ultimaze Tower Wars",
  "MAIN_MENU_PLAY_PVP": "⚔ PvP — Play Now",
  "MAIN_MENU_PLAY": "Play vs Bot",
  "MAIN_MENU_DECK_BUILDER": "🃏 Deck Builder",
  "MAIN_MENU_MY_DECKS": "📂 My Decks",
  "MAIN_MENU_SHOP": "🛒 Shop",
  "MAIN_MENU_INVENTORY": "🎒 Inventory",
  "MAIN_MENU_PROFILE": "📊 PROFILE",
  "MAIN_MENU_SETTINGS": "⚙ Settings",
  "MAIN_MENU_LOGIN_REGISTER": "Login / Register",
  "MAIN_MENU_LOGOUT": "Logout",
  "INVENTORY_TITLE": "Inventory",
  "INVENTORY_BACK": "← Back",
  "INVENTORY_EMPTY": "No unopened packs",
  "INVENTORY_EMPTY_SHOP_LINK": "→ Go to Shop",
  "INVENTORY_OPEN_BTN": "Open",
  "INVENTORY_PACKS_SECTION": "Unopened Packs",
  "SETTINGS_TITLE": "Settings",
  "SETTINGS_LANGUAGE": "Language",
  "SETTINGS_BACK": "← Back",
  "SETTINGS_SOUND": "Sound",
  "LOGIN_TITLE": "Sign In",
  "LOGIN_EMAIL": "E-Mail",
  "LOGIN_PASSWORD": "Password",
  "LOGIN_SUBMIT": "Sign In",
  "LOGIN_REGISTER_LINK": "No account yet? Register →",
  "LOGIN_GUEST": "Play as Guest →",
  "LOGIN_FORGOT_PASSWORD": "Forgot password?",
  "LOGIN_RESET_SEND": "Send reset link",
  "LOGIN_RESET_SENT": "If this email is registered, a reset link has been sent.",
  "LOGIN_BACK_TO_LOGIN": "← Back to login",
  "REGISTER_TITLE": "Register",
  "REGISTER_DISPLAYNAME": "Display Name",
  "REGISTER_SUBMIT": "Register",
  "REGISTER_LOGIN_LINK": "Already registered? Sign In →",
  "REGISTER_CONFIRM_PASSWORD": "Confirm Password",
  "REGISTER_PASSWORD_TOO_SHORT": "Password must be at least 8 characters.",
  "REGISTER_PASSWORDS_MISMATCH": "Passwords do not match.",
  "LEADERBOARD_TITLE": "🏆 Leaderboard",
  "LEADERBOARD_GLOBAL": "Global",
  "LEADERBOARD_NATIONAL": "National",
  "LEADERBOARD_LOADING": "Loading data...",
  "LEADERBOARD_BACK": "← Back",
  "LEADERBOARD_MY_POSITION": "Your position:",
  "LEADERBOARD_TOTAL_PLAYERS": "{{count}} players total",
  "LEADERBOARD_MONTH_LABEL": "Select month",
  "LEADERBOARD_EMPTY": "No entries found.",
  "AUTH_ERROR_INVALID_CREDENTIALS": "E-Mail or password incorrect.",
  "AUTH_ERROR_EMAIL_TAKEN": "This e-mail address is already taken.",
  "AUTH_ERROR_NETWORK": "Network error. Please try again.",
  "AUTH_LOGIN_TITLE": "Sign In",
  "AUTH_REGISTER_TITLE": "Register",
  "AUTH_FORGOT_TITLE": "Reset Password",
  "AUTH_EMAIL": "E-Mail",
  "AUTH_USERNAME": "Username",
  "AUTH_PASSWORD": "Password",
  "AUTH_CONFIRM_PASSWORD": "Confirm Password",
  "AUTH_LOGIN_BTN": "Sign In",
  "AUTH_REGISTER_BTN": "Register",
  "AUTH_FORGOT_BTN": "Send reset link",
  "AUTH_GUEST_BTN": "Play as Guest",
  "AUTH_SWITCH_TO_REGISTER": "No account yet? Register",
  "AUTH_SWITCH_TO_LOGIN": "Already have an account? Sign In",
  "AUTH_SWITCH_TO_FORGOT": "Forgot password?",
  "AUTH_SWITCH_TO_LOGIN_FROM_FORGOT": "Back to Sign In",
  "AUTH_FORGOT_SUCCESS": "If this email is registered, a reset link has been sent.",
  "AUTH_MAIN_MENU_GREETING": "Hello, {{username}}",
  "AUTH_LOGOUT_BTN": "Sign Out",
  "AUTH_LOGIN_REGISTER_BTN": "Sign In / Register",
  "AUTH_ERROR_PASSWORDS_MISMATCH": "Passwords do not match",
  "AUTH_ERROR_USERNAME_TOO_SHORT": "Username must be at least 3 characters",
  "AUTH_ERROR_PASSWORD_TOO_SHORT": "Password must be at least 6 characters",
  "PROGRESSION_TITLE": "Player Profile",
  "PROGRESSION_BACK": "← Back",
  "PROGRESSION_EXPERIENCE": "Experience",
  "PROGRESSION_CURRENCY": "Currency",
  "PROGRESSION_GOLD": "Gold",
  "PROGRESSION_GEMS": "Gems",
  "PROGRESSION_PACK_PROGRESS": "Pack Progress",
  "PROGRESSION_OPEN_PACK": "🎁 Open Pack!",
  "PROGRESSION_DAILY_QUESTS": "Daily Quests",
  "PROGRESSION_WEEKLY_QUESTS": "Weekly Quests",
  "PROGRESSION_ACHIEVEMENT_QUESTS": "Achievement Quests",
  "PROGRESSION_ACHIEVEMENTS": "Achievements (recently unlocked)",
  "PROGRESSION_CARD_COLLECTION": "Card Collection",
  "PROGRESSION_CARDS_COLLECTED": "{{owned}}/{{total}} cards collected",
  "PROGRESSION_DAILY_PACK": "🎁 Daily Pack",
  "PROGRESSION_FRIENDS": "👥 Friends",
  "PROGRESSION_CLAIM": "Claim",
  "DECK_SELECTOR_BACK": "← Back",
  "DECK_SELECTOR_NEW_DECK": "+ New Deck",
  "DECK_SELECTOR_SELECTED": "(selected)",
  "DECK_SELECTOR_CARDS": "cards",
  "DECK_SELECTOR_EDIT": "Edit",
  "DECK_BUILDER_CANCEL": "Cancel",
  "DECK_BUILDER_SAVE": "Save",
  "DECK_BUILDER_NAME_PLACEHOLDER": "Deck Name",
  "DECK_BUILDER_TOTAL_COST": "Total cost:",
  "DECK_BUILDER_TOWERS_SECTION": "TOWERS",
  "DECK_BUILDER_UNITS_SECTION": "UNITS",
  "DECK_BUILDER_HERO_SECTION": "HERO",
  "DECK_BUILDER_ELEMENTS": "Elements",
  "DECK_BUILDER_FILTER_ALL": "All",
  "DECK_BUILDER_EMPTY_SLOT": "Empty — tap to add",
  "DECK_BUILDER_NO_TOWERS": "No towers for this element.",
  "DECK_BUILDER_NO_UNITS": "No units for this element.",
  "DECK_BUILDER_TAB_TOWERS": "Towers",
  "DECK_BUILDER_TAB_UNITS": "Units",
  "DECK_BUILDER_TAB_HEROES": "Heroes",
  "DECK_BUILDER_CHOOSE_TOWER_SLOT": "Choose card for tower slot {{slot}} — or tap slot again to close",
  "DECK_BUILDER_CHOOSE_UNIT_SLOT": "Choose card for unit slot {{slot}}",
  "DECK_BUILDER_CHOOSE_HERO": "Choose hero",
  "DECK_BUILDER_ERROR_NAME": "Deck name is required.",
  "DECK_BUILDER_ERROR_HERO": "A hero is required.",
  "DECK_BUILDER_ERROR_TOWERS": "At least 1 tower is required.",
  "MATCHMAKING_TITLE": "FIND OPPONENT",
  "MATCHMAKING_SEARCHING": "Searching... {{seconds}}s",
  "MATCHMAKING_FOUND": "Opponent found: {{name}}!",
  "MATCHMAKING_ERROR": "Connection error",
  "MATCHMAKING_VS_BOT": "Play vs Bot",
  "MATCHMAKING_RETRY": "Try again",
  "MATCHMAKING_CANCEL": "Cancel",
  "MATCHMAKING_RANK_LABEL": "Your Rank",
  "MATCHMAKING_QUEUE_POSITION": "Queue position: {{position}}",
  "MATCHMAKING_RELAXING": "Expanding search radius...",
  "MATCHMAKING_OPPONENT_RANK": "Opponent rank: {{mmr}}",
  "MATCHMAKING_SERVER_OFFLINE": "Server unavailable",
  "MATCHMAKING_SERVER_OFFLINE_DESC": "No internet or server offline — you'll play offline vs a bot",
  "MATCHMAKING_FALLBACK_TITLE": "No opponent found",
  "MATCHMAKING_FALLBACK_DESC": "You are now playing against a bot",
  "MATCHMAKING_FALLBACK_STARTING": "Match starting...",
  "PACK_OPEN_TITLE": "Open Pack",
  "PACK_OPEN_CLOSE": "Close",
  "PACK_OPEN_NEW": "NEW",
  "DAILY_PACK_CLAIM": "🎁 Claim Free Pack!",
  "DAILY_PACK_TOMORROW": "Available again tomorrow — {{countdown}}",
  "HUD_TOOLTIP_DAMAGE": "Damage",
  "HUD_TOOLTIP_SPEED": "Speed",
  "HUD_TOOLTIP_RANGE": "Range",
  "HUD_TOOLTIP_CRIT": "Crit",
  "HUD_TOOLTIP_SLOW": "Slow",
  "HUD_TOOLTIP_CHAIN": "Chain jumps",
  "HUD_TOOLTIP_INCOME": "Income",
  "HUD_TOOLTIP_ARMOR": "Armor",
  "HUD_TOOLTIP_DODGE": "Dodge",
  "HUD_TOOLTIP_KILL_REWARD": "Kill reward",
  "HUD_QUEST_CLAIMED": "claimed",
  "HUD_SOUND_OFF": "Sound off",
  "HUD_SOUND_ON": "Sound on",
  "HUD_ROTATE_VIEW": "Rotate view (R)",
  "HUD_BUILD": "Build",
  "HUD_SEND_UNIT": "Send unit",
  "HUD_SPY_ENEMY": "Watch opponent",
  "HUD_CANCEL_PLACEMENT": "Cancel placement",
  "HUD_BASE_MAX": "Base MAX",
  "RARITY_COMMON": "Common",
  "RARITY_RARE": "Rare",
  "RARITY_EPIC": "Epic",
  "RARITY_LEGENDARY": "Legendary",
  "PHASER_GOLD_UNIT": "G",
  "PHASER_PACK_TAP_HINT": "Tap a card to reveal",
  "PHASER_PACK_REVEAL_ALL": "Reveal all",
  "PHASER_PACK_CLOSE": "Close",
  "PHASER_PACK_NEW_BADGE": "NEW!",

  "MAP_SELECT_BACK": "← Back",
  "MAP_SELECT_DESC_VULKAN": "Volcanic terrain with narrow paths",
  "MAP_SELECT_DESC_KUESTENFORT": "Coastal fortress with water crossings",
  "MAP_SELECT_DESC_RUINEN": "Ancient ruins with multiple routes",
  "MAP_SELECT_DESC_EISOEDE": "Frozen tundra with crystalline ice blocks",
  "MAP_SELECT_DESC_WUESTE": "Sand-swept arena with diagonal dune ridges",
  "MAP_SELECT_DESC_DSCHUNGEL": "Dense jungle labyrinth with intertwined paths",
  "MAP_SELECT_DESC_HOCHGEBIRGE": "Alpine battlefield with rocky outcrops — Nature and Light dominate",
  "MAP_SELECT_DESC_SUMPF": "Fog-shrouded swamp with twisting bog paths — Water and Shadow reign",

  "HUD_SPELL_COOLDOWN_LABEL": "Cooldown",
  "HUD_SPELL_COOLDOWN_REMAINING": "{{secs}}s remaining",
  "HUD_SPELL_READY_Q": "Ready (Q)",

  "HUD_TOOLTIP_SPLASH": "Splash",
  "HUD_TOOLTIP_RANGE_CELLS": "cells range",

  "SETTINGS_ACCOUNT": "Account",
  "SETTINGS_USERNAME": "Username",
  "SETTINGS_EMAIL": "E-Mail",
  "SETTINGS_PASSWORD": "Password",
  "SETTINGS_CHANGE_PASSWORD": "Change Password",
  "SETTINGS_SERVER": "Server",
  "SETTINGS_SOCIAL": "Link Social Media",
  "SETTINGS_SOCIAL_CONNECT": "Connect",
  "SETTINGS_SOCIAL_CONNECTED": "Connected",
  "SETTINGS_SOCIAL_DISCONNECT": "Disconnect",
  "SETTINGS_PAYMENT": "Payment Methods",
  "SETTINGS_PAYMENT_ADD": "Add",
  "SETTINGS_PAYMENT_CONNECTED": "Linked",
  "SETTINGS_PAYMENT_REMOVE": "Remove",
  "SETTINGS_CURRENT_PASSWORD": "Current Password",
  "SETTINGS_SAVE": "Save",
  "SETTINGS_SAVING": "Saving...",
  "SETTINGS_SAVED": "Saved ✓",
  "SETTINGS_SAVE_ERROR": "Save failed — please try again",
  "SETTINGS_GUEST_NOTE": "Not logged in — language setting saved locally",
  "TUTORIAL_STEP_1_TITLE": "Welcome to Ultimaze Tower Wars!",
  "TUTORIAL_STEP_1_DESC": "Build a labyrinth of towers, send units at your opponent, and destroy their base — before they destroy yours!",
  "TUTORIAL_STEP_2_TITLE": "Building Towers",
  "TUTORIAL_STEP_2_DESC": "Tap an empty cell and select a tower from your hand. Towers automatically shoot at passing units. Important: you can never fully block the path!",
  "TUTORIAL_STEP_3_TITLE": "Sending Units",
  "TUTORIAL_STEP_3_DESC": "Send units at your opponent! Each unit sent permanently increases your income. The faster they reach the base, the more damage they deal.",
  "TUTORIAL_STEP_4_TITLE": "Use Element Strengths",
  "TUTORIAL_STEP_4_DESC": "Every element has strengths and weaknesses. Build your deck around synergistic elements!",
  "TUTORIAL_STEP_4_ELEMENT_CYCLE": "Fire → Nature → Water → Fire (1.8× each)\nElectro → Water (2.0× — sharpest counter!)",
  "TUTORIAL_STEP_4_AXIS": "Light ↔ Shadow: both 2.0× — hard counter in both directions!",
  "TUTORIAL_STEP_5_TITLE": "Ready for your first match!",
  "TUTORIAL_STEP_5_DESC": "Tutorial complete! Your reward:",
  "TUTORIAL_NEXT": "Next →",
  "TUTORIAL_SKIP": "Skip",
  "TUTORIAL_COMPLETE": "Start Match! 🎮",
  "TUTORIAL_REWARD_TITLE": "Tutorial Reward",
  "TUTORIAL_REWARD_XP": "+150 XP",
  "TUTORIAL_REWARD_GOLD": "+200 Gold",
  "TUTORIAL_REWARD_PACK": "+1 Starter Pack",
  "TUTORIAL_ACHIEVEMENT_UNLOCKED": "🏆 Achievement unlocked: Tutorial complete!",
  "TOAST_QUEST_COMPLETED": "Quest complete: {{title}}",
  "TOAST_ACHIEVEMENT_UNLOCKED": "🏆 Achievement: {{title}}",
  "TOAST_MATCH_WIN": "Victory! +{{xp}} XP earned",
  "TOAST_REWARD_CLAIMED": "Reward claimed: +{{xp}} XP, +{{gold}} Gold",
  "TOAST_TUTORIAL_REWARD": "🎁 Tutorial reward received! +150 XP, +200 Gold, +1 Pack",
  "FEEDBACK_TITLE": "Feedback & Bug Report",
  "FEEDBACK_BACK": "Back",
  "FEEDBACK_TYPE_LABEL": "Type",
  "FEEDBACK_TYPE_BUG": "🪲 Bug",
  "FEEDBACK_TYPE_IDEA": "💡 Idea",
  "FEEDBACK_TYPE_OTHER": "💬 Other",
  "FEEDBACK_TITLE_LABEL": "Title",
  "FEEDBACK_TITLE_PLACEHOLDER": "Short description (max 120 characters)",
  "FEEDBACK_DESC_LABEL": "Description",
  "FEEDBACK_DESC_PLACEHOLDER": "What happened? Steps to reproduce, suggestion, etc. (max 2000 characters)",
  "FEEDBACK_SUBMIT": "Submit",
  "FEEDBACK_SUBMITTING": "Sending...",
  "FEEDBACK_SUCCESS_TITLE": "Thanks for your feedback!",
  "FEEDBACK_SUCCESS_DESC": "We take every report seriously. Keep your report ID to check the status later.",
  "FEEDBACK_SUCCESS_ID": "Your report ID:",
  "FEEDBACK_ERROR": "Failed to send. Please try again.",
  "FEEDBACK_VALIDATION_REQUIRED": "Please fill in all fields.",
  "FEEDBACK_MY_REPORTS_TITLE": "My Reports",
  "FEEDBACK_STATUS_NEW": "🆕 Received",
  "FEEDBACK_STATUS_REVIEWING": "🔍 Under Review",
  "FEEDBACK_STATUS_CONFIRMED": "✅ Confirmed",
  "FEEDBACK_STATUS_RESOLVED": "🔧 Resolved",
  "FEEDBACK_STATUS_REJECTED": "❌ Rejected",
  "FEEDBACK_ACHIEVEMENT_HINT": "Confirmed & resolved reports count toward the Bug-Tracker achievement!",
  "FEEDBACK_BTN_REPORT": "Feedback / Report a bug",
  "ERROR_BOUNDARY_HEADING": "Something went wrong",
  "ERROR_BOUNDARY_RELOAD": "Reload",
  "OFFLINE_BANNER_TEXT": "No internet connection — PvP and online features are unavailable",
  "PUSH_MODAL_TITLE": "Stay in the game!",
  "PUSH_MODAL_BODY": "Get daily pack reminders and notifications when opponents are found.",
  "PUSH_MODAL_BULLET_PACK": "✅ Free daily pack reminders",
  "PUSH_MODAL_BULLET_PVP": "✅ PvP match notifications",
  "PUSH_MODAL_ACCEPT": "Yes, allow notifications",
  "PUSH_MODAL_SETTING_UP": "Setting up...",
  "PUSH_MODAL_DECLINE": "Not now",
  "LEADERBOARD_COL_RANK": "#",
  "LEADERBOARD_COL_NAME": "Name",
  "LEADERBOARD_COL_COUNTRY": "Country",
  "LEADERBOARD_COL_POINTS": "Points",
  "LEADERBOARD_COL_LEAGUE": "League",
  "LEADERBOARD_TAB_GLOBAL": "Global",
  "LEADERBOARD_TAB_FRIENDS": "Friends",
  "LEADERBOARD_RANK": "#",
  "LEADERBOARD_PLAYER": "Player",
  "LEADERBOARD_RECORD": "W-L",
  "LEADERBOARD_POINTS": "ELO",
  "LEADERBOARD_LOGIN_PROMPT": "Sign in to view the leaderboard",
  "LEADERBOARD_YOU": "You",
  "SETTINGS_SOCIAL_SHARING_NOTE": "Share decks, match stats and leaderboard results directly via your social media channels.",
  "SETTINGS_PAYMENT_NOTE": "We do not store payment data. All processing is handled exclusively by the respective provider (PayPal, Apple Pay, etc.).",
  "MAP_SELECT_SYNERGY": "SYNERGY",
  "BOT_NAMES": ["Valdris the Dark", "Sylara the Swift", "Gorak Stonebreaker", "Mira Flameheart", "Theron the Guardian", "Nyx Shadowweaver", "Aldric the Undefeated", "Sora Windblade"],
  "MATCHMAKING_ANON_PREFIX": "Player",
  "ELEMENT_NAME_FIRE": "Fire",
  "ELEMENT_NAME_WATER": "Water",
  "ELEMENT_NAME_NATURE": "Nature",
  "ELEMENT_NAME_ELEKTRO": "Electric",
  "ELEMENT_NAME_LIGHT": "Light",
  "ELEMENT_NAME_SHADOW": "Shadow",
  "ELEMENT_NAME_NEUTRAL": "Neutral",
  "QUEST_SEND_UNITS_10": "Send 10 Units",
  "QUEST_WIN_MATCH": "Win a Match",
  "QUEST_BUILD_20_TOWERS": "Build 20 Towers in One Round",
  "QUEST_WIN_5_PVP": "Win 5 PvP Matches",
  "QUEST_COMPLETE_TUTORIAL": "Tutorial Completed",
  "QUEST_BUG_TRACKER_BRONZE": "🪲 Bug Tracker Bronze",
  "QUEST_BUG_TRACKER_SILBER": "🪲 Bug Tracker Silver",
  "QUEST_BUG_TRACKER_GOLD": "🪲 Bug Tracker Gold",
  "QUEST_BUG_TRACKER_PLATIN": "🪲 Bug Tracker Platinum",
  "QUEST_BUG_TRACKER_DIAMANT": "🪲 Bug Tracker Diamond",
  "QUEST_SEND_UNITS_10_DESC": "Send 10 units at the opponent in a single match.",
  "QUEST_WIN_MATCH_DESC": "Win a match against an opponent or bot.",
  "QUEST_BUILD_20_TOWERS_DESC": "Place 20 towers on the grid in a single round.",
  "QUEST_WIN_5_PVP_DESC": "Win 5 PvP matches this week.",
  "BOOT_LOADING_GAMEDATA": "Loading game data...",
  "BOOT_LOADING_READY": "Ready!",
  "FRIENDS_TAB_LIST": "Friends",
  "FRIENDS_TAB_REQUESTS": "Requests",
  "FRIENDS_TAB_SEARCH": "Search",
  "FRIENDS_LOADING": "Loading friends...",
  "FRIENDS_EMPTY": "No friends yet. Search for players!",
  "FRIENDS_NO_REQUESTS": "No pending requests.",
  "FRIENDS_CHALLENGE": "Send challenge",
  "FRIENDS_CHALLENGE_SENT": "Challenge sent! They have 60 seconds to accept.",
  "FRIENDS_CHALLENGE_OFFLINE": "This player is not online right now.",
  "FRIENDS_ACCEPT": "Accept",
  "FRIENDS_DECLINE": "Decline",
  "FRIENDS_REQUEST_ACCEPTED": "Friend request accepted!",
  "FRIENDS_REQUEST_SENT": "Request sent!",
  "FRIENDS_REQUEST_ERROR": "Failed to send request.",
  "FRIENDS_ADD": "Add",
  "FRIENDS_ALREADY_FRIENDS": "Already friends",
  "FRIENDS_PENDING": "Request pending",
  "FRIENDS_SEARCH_PLACEHOLDER": "Enter name or #CODE...",
  "FRIENDS_SEARCHING": "Searching...",
  "FRIENDS_SEARCH_EMPTY": "No players found.",
  "FRIENDS_LOGIN_REQUIRED": "Please log in to use the friends system.",

  "INVENTORY_TAB_PACKS": "Packs",
  "INVENTORY_TAB_CARDS": "Cards",
  "INVENTORY_CARDS_EMPTY": "No cards yet. Open packs!",
  "INVENTORY_CARD_COPIES": "{{copies}}×",

  "CARD_DETAIL_BACK": "Back",
  "CARD_DETAIL_NOT_FOUND": "Card not found.",
  "CARD_DETAIL_LEVEL": "Lv. {{level}}",
  "CARD_DETAIL_COPIES_TO_NEXT": "{{have}} / {{needed}} copies to next level",
  "CARD_DETAIL_MAX_LEVEL": "MAX LEVEL reached",
  "CARD_DETAIL_LEVEL_BONUSES": "Level Bonuses",
  "CARD_DETAIL_STATS": "Stats",
  "CARD_DETAIL_STATS_BASE": "Base",
  "CARD_DETAIL_STATS_CURRENT": "Current",
  "CARD_DETAIL_SKILL_TREE": "Skill Tree",
  "CARD_DETAIL_GATE_LEVEL": "Gate Lv. {{level}}",
  "CARD_DETAIL_GATE_LOCKED": "locked (requires Lv. {{level}})",
  "CARD_DETAIL_GATE_CHOOSE": "Choose!",
  "CARD_DETAIL_GATE_DONE": "chosen",
  "CARD_DETAIL_CHOOSE": "Choose",
  "CARD_DETAIL_NODE_REQUIRES": "Requires: {{id}}",
  "CARD_DETAIL_RESET": "Reset ({{cost}} 💎)",
  "CARD_DETAIL_RESET_NO_GEMS": "Not enough gems (150 required)",
  "CARD_DETAIL_CAT_TOWER": "TOWER",
  "CARD_DETAIL_CAT_UNIT": "UNIT",
  "CARD_DETAIL_CAT_HERO": "HERO",
  "CARD_DETAIL_STAT_DMG": "Damage",
  "CARD_DETAIL_STAT_SPD": "Speed",
  "CARD_DETAIL_STAT_RANGE": "Range",
  "CARD_DETAIL_STAT_CRIT": "Crit Chance",
  "CARD_DETAIL_STAT_SPLASH": "Splash",
  "CARD_DETAIL_STAT_SLOW": "Slow",
  "CARD_DETAIL_STAT_CHAIN": "Chain",
  "CARD_DETAIL_STAT_INCOME": "Income",
  "CARD_DETAIL_STAT_ARMOR": "Armor",
  "CARD_DETAIL_STAT_DODGE": "Dodge",
  "CARD_DETAIL_STAT_PASSIVE": "Passive",
  "CARD_DETAIL_STAT_COOLDOWN": "Cooldown",

  "CHALLENGE_MODAL_TITLE": "Battle Challenge!",
  "CHALLENGE_MODAL_FROM": "{{name}} challenges you!",
  "CHALLENGE_MODAL_ACCEPT": "Accept",
  "CHALLENGE_MODAL_DECLINE": "Decline",
  "CHALLENGE_MODAL_EXPIRES": "Expires in {{seconds}}s",

  "LOGIN_OR": "or",
  "LOGIN_GOOGLE": "Sign in with Google",

  "TUTORIAL_DECK_TITLE": "Build your first deck",
  "TUTORIAL_DECK_DESC": "Choose 8 towers, 4 units and 1 hero for your starter deck.",
  "TUTORIAL_DECK_CONFIRM": "Confirm Deck & Start",
  "TUTORIAL_DECK_NAME": "My First Deck",

  "MODE_SELECT_TITLE": "Choose Game Mode",
  "MODE_SELECT_SUB": "How many players will fight?",
  "MODE_1V1_TITLE": "1 vs 1",
  "MODE_1V1_DESC": "Classic duel — you vs. one opponent",
  "MODE_2V2_TITLE": "2 vs 2",
  "MODE_2V2_DESC": "Team battle with one teammate",
  "MODE_3V3_TITLE": "3 vs 3",
  "MODE_3V3_DESC": "Epic team battle — 3 vs. 3",

  "MAIN_MENU_CAMPAIGN": "📖 Solo Campaign",

  "CAMPAIGN_TITLE": "Solo Campaign",
  "CAMPAIGN_SUBTITLE": "5 missions — from beginner to champion",
  "CAMPAIGN_MISSION_N": "Mission {{n}}",
  "CAMPAIGN_OBJECTIVE": "Objective",
  "CAMPAIGN_HINT": "Complete a mission to unlock the next one.",
  "CAMPAIGN_COMPLETE_TOAST": "Mission complete! +{{xp}} XP, +{{gold}} Gold",
  "CAMPAIGN_FAIL_TOAST": "Mission failed — try again!",

  "CAMPAIGN_M1_TITLE": "First Steps",
  "CAMPAIGN_M1_DESC": "A beginner bot awaits. Learn the basics!",
  "CAMPAIGN_M1_OBJ": "Destroy the enemy base",

  "CAMPAIGN_M2_TITLE": "The Horde",
  "CAMPAIGN_M2_DESC": "The attacker sends endless waves. Hold the line!",
  "CAMPAIGN_M2_OBJ": "Defeat 30 enemy units",

  "CAMPAIGN_M3_TITLE": "Gold Rush",
  "CAMPAIGN_M3_DESC": "Optimize your economy loop against a defensive opponent.",
  "CAMPAIGN_M3_OBJ": "Reach 10 gold/sec income",

  "CAMPAIGN_M4_TITLE": "Creature Flood",
  "CAMPAIGN_M4_DESC": "A swarm bot bombards you relentlessly. Survive 8 minutes!",
  "CAMPAIGN_M4_OBJ": "Survive for 8 minutes",

  "CAMPAIGN_M5_TITLE": "The Champion",
  "CAMPAIGN_M5_DESC": "The smartest bot — uses element counters and adapts. Only the best can defeat it.",
  "CAMPAIGN_M5_OBJ": "Destroy the Champion's base",

  "MAIN_MENU_COOP": "🤝 Coop PvE",
  "COOP_MATCHMAKING_TITLE": "Coop PvE",
  "COOP_MATCHMAKING_SEARCHING": "Looking for partner...",
  "COOP_MATCHMAKING_FOUND": "Partner found!",
  "COOP_MATCHMAKING_PARTNER": "Partner: {{name}}",
  "COOP_MATCHMAKING_STARTING": "Starting co-op defense...",
  "COOP_MATCHMAKING_FALLBACK": "No partner found",
  "COOP_MATCHMAKING_FALLBACK_DESC": "You'll fight alone against the bots.",
  "COOP_MATCHMAKING_CANCEL": "Cancel",
  "COOP_MATCHMAKING_OFFLINE": "Server unavailable",
  "COOP_MATCHMAKING_OFFLINE_DESC": "Solo coop: defending alone against bots.",
  "HUD_COOP_PARTNER_HP": "Partner ♥",
  "HUD_COOP_PARTNER_DEFEATED": "Partner defeated!",

  "SEASON_DAYS_LEFT": "{{days}} days remaining",
  "SEASON_LEVEL_LABEL": "Level {{level}} / {{max}}",
  "SEASON_PREMIUM_DESC": "Unlock the premium track — exclusive gems, packs and a title for every level.",
  "SEASON_BUY_PASS": "Buy Season Pass",
  "SEASON_PREMIUM_ACTIVE": "Premium track unlocked — all premium rewards available!",
  "SEASON_PASS_OWNED": "Owned ✓",
  "SEASON_TRACK_FREE": "Free",
  "SEASON_TRACK_PREMIUM": "Premium",
  "SEASON_CLAIM": "Claim",
  "SEASON_CLAIMED": "Claimed ✓",
  "SEASON_LOCKED": "Locked",
  "SEASON_PREMIUM_ONLY": "Premium only",
  "SEASON_CLAIMED_COUNT": "{{count}} / {{total}} rewards claimed",
  "SEASON_XP_LABEL": "Season XP",

  "FRIENDS_TITLE": "Friends",
  "FRIENDS_TAB_FRIENDS": "Friends",
  "FRIENDS_ADD_PLACEHOLDER": "Enter player code (#XXXXXX)",
  "FRIENDS_SEND_REQUEST": "Send Request",
  "FRIENDS_REMOVE": "Remove",
  "FRIENDS_CHALLENGE_SENT": "Challenge sent! 60 seconds to accept.",

  "REPLAY_TITLE": "Match History",
  "REPLAY_EMPTY": "No matches played yet.",
  "REPLAY_OUTCOME_WIN": "Victory",
  "REPLAY_OUTCOME_LOSS": "Defeat",
  "REPLAY_OUTCOME_DRAW": "Draw",
  "REPLAY_VIEW_BUTTON": "Replay",
  "REPLAY_NO_DATA": "No replay data available.",
  "REPLAY_TIMELINE_TITLE": "Match Timeline",
  "REPLAY_HP_CHART_LABEL": "HP Chart",
  "REPLAY_GOLD_CHART_LABEL": "Gold Chart",
  "REPLAY_EVENTS_LABEL": "Key Events",
  "REPLAY_CLOSE": "Close",
  "REPLAY_PLAY": "Play",
  "REPLAY_PAUSE": "Pause",
  "REPLAY_MY_HP":      "My HP",
  "REPLAY_OPP_HP":     "Opponent HP",
  "REPLAY_HP_CHART":   "HP Chart",
  "REPLAY_KEY_EVENTS": "Key Events",
  "REPLAY_VIEW_BTN":   "Replay",

  "PROFILE_TITLE": "My Profile",
  "PROFILE_STATS": "Statistics",
  "PROFILE_AVATAR": "Choose Avatar",
  "PROFILE_BIO": "Bio",
  "PROFILE_SAVE": "Save",
  "PROFILE_SAVED": "Saved!",
  "PROFILE_WINRATE": "Win Rate",

  "SEASON_ENDS_IN": "Season ends in {{days}} days",
  "SEASON_ENDED": "Season over! Claim your rewards.",
  "SEASON_CLAIM_REWARDS": "Claim Rewards",
  "SEASON_REWARDS_CLAIMED": "Rewards received!",
  "SEASON_NEXT": "Next Season",
  "SEASON_TITLE_EARNED": "Title earned",

  "SPECTATOR_TITLE":   "Live Matches",
  "SPECTATOR_LIVE":    "LIVE",
  "SPECTATOR_EMPTY":   "No active matches right now.",
  "SPECTATOR_WATCH":   "Watch",
  "SPECTATOR_LEAVE":   "Leave",
  "SPECTATOR_PLAYER1": "Player 1",
  "SPECTATOR_PLAYER2": "Player 2",
  "SPECTATOR_BACK":    "Back",

  "TOURNAMENT_TITLE":          "Tournament",
  "TOURNAMENT_JOIN":           "Join",
  "TOURNAMENT_JOINED":         "Successfully joined!",
  "TOURNAMENT_FULL":           "Tournament is full!",
  "TOURNAMENT_BRACKET":        "Bracket",
  "TOURNAMENT_MY":             "My Tournament",
  "TOURNAMENT_EMPTY":          "No open tournament. Check back later!",
  "TOURNAMENT_STATUS_OPEN":    "Open",
  "TOURNAMENT_STATUS_RUNNING": "Running",
  "TOURNAMENT_CHAMPION":       "Champion",

  "CHAT_PLACEHOLDER":     "Message...",
  "CHAT_SEND":            "Send",
  "CHAT_TOGGLE":          "Chat",
  "CHAT_NO_MESSAGES":     "No messages yet",
  "CHAT_QUICK_PHRASE_GG": "GG — send quick phrase",
  "CHAT_RATE_LIMIT":      "Please wait a moment before sending again.",

  "STREAK_TITLE":      "Login Reward",
  "STREAK_BROKEN":     "Streak lost — but restarted today!",
  "STREAK_DAY":        "Day {{day}} Login Reward",
  "STREAK_CLAIM":      "Collect!",
  "STREAK_JACKPOT":    "7-Day Streak complete!",
  "STREAK_DAYS_LABEL": "Streak: {{day}} day{{plural}}",

  "CLAN_TITLE":       "Clans",
  "CLAN_MY":          "My Clan",
  "CLAN_SEARCH":      "Search",
  "CLAN_CREATE":      "Create",
  "CLAN_LEADERBOARD": "Leaderboard",
  "CLAN_JOIN":        "Join",
  "CLAN_LEAVE":       "Leave Clan",
  "CLAN_NAME":        "Clan Name",
  "CLAN_TAG":         "Tag",
  "CLAN_DESC":        "Description",
  "CLAN_FULL":        "Clan is full (max 50 members)",
  "CLAN_EMPTY":       "No clans found",
  "CLAN_CREATED":     "Clan created",
  "CLAN_JOINED":      "Joined",
  "CLAN_LEFT":        "Left clan",
  "CLAN_OWNER":       "Leader",
  "CLAN_MEMBER":      "Member",
  "CLAN_OFFICER":     "Officer",
  "CLAN_NOT_IN_CLAN":        "You are not in a clan",
  "CLAN_TOTAL_ELO":          "Total ELO",
  "CLAN_SEARCH_PLACEHOLDER": "Search clan name / TAG…",
  "CLAN_TAG_HINT":           "3–5 uppercase letters or digits (e.g. FIRE)"
}
